<template>
  <div class="Comment__container">
    <span v-html="comment"></span>
  </div>
</template>

<script>
export default {
  name: "Comment",
  props: {
    comment: {
      type: String,
    },
  },
};
</script>

<style lang="scss">
@import "web/themes/custom/khst_theme/_sass-config/sass-config";

 .Comment__container {
  margin-bottom: 30px;
 }
</style>
